export default __webpack_public_path__ + "media/images/email-c1bdbfba0cc0bdad247e8f49467a83b6.svg";